import { useQuery } from '@tanstack/react-query';

export function useFeatureFlag(agentSlug?: string, featureName?: string) {
  const { data: isEnabled = false } = useQuery(
    ['phoenix_feature_flags', agentSlug, featureName],
    async () => {
      const res = await fetch(
        `/api/feature-flag?slug=${agentSlug}&feature=${featureName}`,
      );
      if (!res.ok) return false;
      return res.json();
    },
    {
      enabled: !!agentSlug && !!featureName,
      staleTime: 5 * 60 * 1000,
      retry: false,
    },
  );

  return isEnabled;
}
